<template lang="pug">
  .flow-builder-action-find-product
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(
        v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)",
        :key="platform.platform_id",
        :style="{'background-color': platformColor(platform.name, 0.7)}"
      ) {{ platform.title }}
      b-badge(
        v-if="selectedPlatformsObjects.slice(sliceEnd).length",
        variant="soft-secondary"
      ) {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(
          placeholder="- Agregar plataformas -",
          :options="parsedPlatforms",
          :disabled="disabled",
          :value="selected_platforms",
          @input="updatePlatforms",
          multiple,
          :limit="3",
          :searchable="false",
        )
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Pago automático
        p.text-secondary.text-sm
          | Este template permite a tus clientes realizar pagos automáticos,
          | configurando el monto, la referencia y la pasarela de pago.
        fieldset(:disabled="disabled")
          b-form-group(
            label="Nombre de la suscripción:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'subscription_name'"
          )
            b-form-input(
              placeholder="Suscripción",
              :value="template_attribute.value",
              @click="updateTemplateAttribute(template_attribute, $event)"
            )
          b-form-group(
            label="Monto:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'amount'"
          )
            b-form-input(
              placeholder="Monto",
              type="number",
              v-model="template_attribute.value",
              @click="updateTemplateAttribute(template_attribute, $event)"
              controls,
              inline,
              center,
              :step="0.1"
            )
          b-form-group(
            label="Periodo:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'period'"
          )
            b-form-input(
              placeholder="Periodo",
              type="number",
              v-model="template_attribute.value",
              @click="updateTemplateAttribute(template_attribute, $event)"
              controls,
              inline,
              center,
              :step="1"
            )
          b-form-group(
            label="Id de tarjeta:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'card_id'"
          )
            b-form-input(
              placeholder="Id de tarjeta",
              v-model="template_attribute.value",
              @click="updateTemplateAttribute(template_attribute, $event)"
              controls,
              inline,
              center,
            )
          b-form-group(
            label="Referencia:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'reference'"
          )
            b-form-textarea.disabled-white(
              :value="template_attribute.value",
              placeholder="Referencia",
              @click="updateTemplateAttribute(template_attribute, $event)")
          .d-flex
          b-form-group(
            label="Pasarela de pago:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'payment_type'"
          )
            k-select.disabled-white(
              placeholder="- Seleccionar pasarela -", :options="paymentGateways", :disabled="disabled", :value="template_attribute.value || null",
              @input="updateTemplateAttribute(template_attribute, $event)"
            )
      template-connector(
        v-for="connector in Template_Connectors",
        :key="connector.template_connector_id",
        v-bind="connector",
        :block_id="block_id",
        :disabled="disabled"
      )
</template>

<script>
import templateCommon from '@/helpers/template-common'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'
import Connector from '@/components/templates/connectors/Connector.vue'

export default {
  mixins: [templateCommon],
  data() {
    return {}
  },
  components: {
    'template-tools': TemplateTools,
    'template-connector': Connector
  },
  computed: {
    paymentGateways() {
      return [{ label: 'Centro de pagos', id: 'paymentCenter' }]
    }
  },
  methods: {},
  created() {
    this.updateTemplateAttribute = _debounce(
      (templateAttribute, value) => {
        const attribute = JSON.parse(JSON.stringify(templateAttribute))
        if (value && value.target) {
          attribute.value = value.target._value
        } else {
          attribute.value = value
        }

        this.updateAttribute(this.block_id, this.template_id, attribute).then(
          () => {
            this.$message.success('Actualizado')
          }
        )
      },
      100,
      { leading: false, trailing: true }
    )
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.flow-builder-action-find-product {
  position: relative;
  flex: 1 0 auto;
  max-width: 100%;
  background-color: transparent;
  white-space: normal;
}
</style>
